import { fetchExtensionLocationSuggestions, LocationSuggestionsResult } from 'lib/extensionMessaging';

export const ZIPRECRUITER_LOCATION_TYPEAHEAD_MESSAGE = 'harbor-ziprecruiter-location-typeahead';

export type ZipRecruiterLocationSuggestionsResult = LocationSuggestionsResult;

export function fetchZipRecruiterLocationSuggestions(
  query: string,
): Promise<ZipRecruiterLocationSuggestionsResult> {
  return fetchExtensionLocationSuggestions(ZIPRECRUITER_LOCATION_TYPEAHEAD_MESSAGE, { query });
}
